<template>
    <main
        class="guideline-layout"
        :data-sidebar="!!$slots.sidebar"
        :data-searching="!!searchQuery"
    >
        <aside
            v-if="$slots.sidebar"
            class="guideline-layout__sidebar"
        >
            <slot name="sidebar" />
        </aside>

        <article class="guideline-layout__content">
            <slot />
        </article>
        <BaseScrollToTop />
    </main>
</template>

<script setup>
import { useGuidelineSearchStore } from '~/store/guideline-search';

const { searchQuery } = useGuidelineSearchStore();
</script>

<style lang="less">
.guideline-layout {
    margin-top: var(--spacing-xl);

    @media @q-lg-min {
        margin-top: 3rem;
    }

    .sticky-bar + & {
        @media @q-md-max {
            margin-top: var(--spacing-lg);
        }
    }
}

.guideline-layout:not([data-sidebar='true']) {
    .grid-bleed;
    .grid-container(true, var(--grid-maxWidth-content));
}

.guideline-layout[data-wide] {
    .grid-container(true, var(--grid-maxWidth-page));
}

.guideline-layout[data-sidebar='true'] {
    display: grid;
    grid-template-areas: 'aside aside' 'content content';
    grid-template-columns: minmax(0, 1fr);
    column-gap: 2.5rem;

    @media @q-md-min {
        row-gap: var(--spacing-xl);
        grid-template-areas: 'aside content';
        grid-template-columns: 15rem minmax(0, 1fr);
    }

    @media @q-lg-min {
        grid-template-columns: 20rem minmax(0, 1fr);
        row-gap: 3rem;
    }

    @media @q-xl-min {
        grid-template-columns: 25.375rem minmax(0, 1fr);
    }

    .guideline-layout__aside {
        grid-area: aside;
    }

    .guideline-layout__content {
        grid-area: content;
    }
}
</style>

<style lang="less">
.guideline-layout--narrow {
    .flexible-sections, .section--wide {
        display: block;

        .section__title h2 {
            .typography-h4();
        }

        .section__content p {
            margin-top: 0;
        }

        .card__title {
            .typography-label();

            @media @q-lg-min {
                font-size: var(--font-size-md);
            }
        }

        .pill {
            font-size: var(--font-size-xxs);
        }
    }
}
</style>
